<template>
  <div
    class="mt-11 text-center apply-button"
  >
    <p-button
      style="padding-left: 65px; padding-right: 65px;"
      v-on="$listeners"
      @click="onApplyClicked"
    >
      apply
    </p-button>
      <a class="filter-cancel-text cursor-pointer align-middle" @click="onCancel">CANCEL</a>
  </div>
</template>

<script>
import PButton from '~/components/core/PButton'

export default {
  name: 'ApplyButton',
  components: { PButton },
  props: {
    checkBoxObject: Object,
  },
  watch: {
    checkBoxObject : function name(params) {
        // console.log('watcher',params)
    }
  },
  methods: {
    onApplyClicked () {
      this.$emit('apply')
    },
    onCancel() {
      this.$emit('toggleSection')
    }
  }
}
</script>

<style scoped>
.mt-11 {
  margin-top: 11px;
}
.apply-button {
  position: absolute;
  bottom: 9px;
  display: flex;
  width: 100%;
  justify-content: center;
}
.filter-cancel-text {
  display: none;
}
@media  (max-width:1280px) {
  .filter-cancel-text {
    height: 48px;
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding-left: 24px;
    font: normal normal normal 12px/14px Arial;
    letter-spacing: 0px;
    color: #31B4D6;
  }
}
@media (max-width: 700px) { 
  .apply-button {
    width: 100%;
    display: block;
    bottom: 7px;
  }
}
</style>
